import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import Inspector from 'react-inspector';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Loader } from '../../../components/Loader';
import { selectWorks } from '../../Api/selectors';
import { fromAutotelex } from '../actions';
import { VehiclePropertiesEditor } from '../components/VehiclePropertiesEditor';
import { REQUEST_VEHICLE_FROM_AUTOTELEX } from '../constants';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class VehicleDetailsVarsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  get vehicle() {
    return this.props.vehicle;
  }

  fromAutoTelex() {
    this.props.fromAutoTelex();
  }

  render() {
    return (
      <Container>
        {this.props.work ? (
          <Loader small />
        ) : (
          <VBox>
            <HBox>
              <VehiclePropertiesEditor vehicle={this.vehicle} />
              <Inspector data={this.vehicle} expandLevel={1}></Inspector>
            </HBox>
            {/* <hr />
            <Button small inline onClick={this.fromAutoTelex.bind(this)}>
              Uit Autotelex laden
            </Button> */}
          </VBox>
        )}
      </Container>
    );
  }
}

VehicleDetailsVarsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE_FROM_AUTOTELEX + ownProps.vehicle.id]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fromAutoTelex(callback) {
      dispatch(fromAutotelex(ownProps.vehicle.id, null, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const VehicleDetailsVars = compose(
  withConnect,
  withRouter,
)(VehicleDetailsVarsComp);
